import { useEffect, useState } from "react";
import axios from "axios";

// Material, condition and style are managed by an admin rather than hardcoded,
// so every form that offers them reads the same list from one place.
//
// The previous values are kept as a fallback: if the request fails, a seller
// still sees the options the form has always offered rather than an empty
// dropdown that silently blocks them from listing.
const FALLBACK = {
  material: [
    "NA", "Silk", "Cotton", "Pattu", "Crepe", "Net", "Georgette", "Rayon",
    "Polyester", "Wool", "Linen", "Nylon", "Denim", "Leather", "Velvet",
    "Spandex Elastane",
  ],
  condition: ["NA", "Brand New", "Like New", "Excellent", "Good", "Fair"],
  style: ["NA", "Modern", "00s", "90s", "80s", "70s", "60s", "50s", "Antique"],
};

const asOptions = (values) => values.map((value, i) => ({ id: `fallback-${i}`, value }));

export function useProductOptions() {
  const [options, setOptions] = useState({
    material: asOptions(FALLBACK.material),
    condition: asOptions(FALLBACK.condition),
    style: asOptions(FALLBACK.style),
  });

  useEffect(() => {
    let cancelled = false;
    axios
      .get(`${process.env.REACT_APP_HOST}${process.env.REACT_APP_PORT}/productattributes`)
      .then((res) => {
        if (cancelled || !res.data || typeof res.data !== "object") return;
        // Only replace a list the server actually returned something for.
        setOptions((current) => ({
          material: res.data.material?.length ? res.data.material : current.material,
          condition: res.data.condition?.length ? res.data.condition : current.condition,
          style: res.data.style?.length ? res.data.style : current.style,
        }));
      })
      .catch((err) => {
        console.error("Could not load product options, using defaults:", err.message);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return options;
}

export default useProductOptions;
